<!-- contenu de ta modale -->
<section class="w-full rounded-md border border-gray-200 bg-white px-20 py-10">
  <div class="flex flex-1 flex-col justify-center text-center md:gap-10">
    <div class="flex flex-col gap-4">
      <h2 class="text-primary-900">
        {{ "manageSubscription.updateCompanyInfo.title" | transloco }}
      </h2>
      <p class="text-paragraph-s-reg">
        {{ "manageSubscription.updateCompanyInfo.description" | transloco }}
      </p>
    </div>
    <form
      class="flex flex-col items-center md:flex-row"
      [formGroup]="companyInfoForm"
    >
      <div class="flex w-full flex-col gap-8">
        <div class="flex flex-col items-start">
          <label
            for="vatNumber"
            class="text-paragraph-xs-med text-greyscale-700"
          >
            {{ "accountMenu.billingInformation.vatNumber" | transloco }}
          </label>
          <input
            pInputText
            id="vatNumber"
            formControlName="vatNumber"
            [fluid]="true"
            [placeholder]="
              'accountMenu.billingInformation.placeholder.vatNumber' | transloco
            "
          />
          <app-error [control]="companyInfoForm.get('vatNumber')!" />
        </div>

        <div class="flex flex-1 flex-col items-start">
          <label for="size" class="text-paragraph-xs-med text-greyscale-700">
            {{ "accountMenu.billingInformation.companySize" | transloco }}
          </label>
          <p-select
            id="size"
            formControlName="size"
            [placeholder]="
              'accountMenu.billingInformation.placeholder.companySize'
                | transloco
            "
            [options]="sizeOptions"
            class="w-full"
          />
          <app-error [control]="companyInfoForm.get('size')!" />
        </div>
      </div>
    </form>
    <div class="flex w-full items-end justify-end">
      <p-button
        [label]="'save' | transloco"
        (click)="submit()"
        [disabled]="companyInfoForm.invalid"
      />
    </div>
  </div>
</section>
